import CrudGenerator from 'admin/pages/shared/CrudGenerator/CrudGenerator';
import { columns, formSchema } from './TasksConfig';
import TasksService from './TasksService';
import './style.scss';
import tasksDetails from './TasksDetails';


export default CrudGenerator({
    columns,
    formSchema,
    route: '/admin/tasks',
    entityName: {
        entityNamePlural: "Tasks",
        entityNameSingular: "Task"
    },
    getEntities: TasksService.getTasks,
    editEntity: TasksService.editTasks,
    deleteEntities: TasksService.deleteTasks,
    modalDetails: tasksDetails
})